import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function MentionsLegalesPage() {
  return (
    <div className="bg-stone-100 min-h-screen" data-testid="mentions-legales-page">
      {/* Header */}
      <section className="bg-white border-b border-stone-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 font-inter text-sm text-stone-500 hover:text-red-800 transition-colors duration-200 mb-6"
            data-testid="mentions-back-home"
          >
            <ArrowLeft className="h-4 w-4" />
            Accueil
          </Link>
          
          <h1 className="font-playfair text-4xl sm:text-5xl font-bold text-stone-900">
            Mentions légales
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white border border-stone-200 p-8 lg:p-12">
          <article className="article-content text-stone-800">
            
            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6">
              Éditeur du site
            </h2>
            
            <div className="mb-8 pl-6 border-l-4 border-red-800">
              <p className="font-lora text-lg mb-2">
                <strong>LE POOL PRESSE</strong>
              </p>
              <p className="font-inter text-base text-stone-600">
                Société par Actions Simplifiée (SAS)
              </p>
            </div>

            <div className="space-y-4 mb-8">
              <p className="font-inter text-base">
                <span className="font-semibold">Siège social :</span> 9 La Farinière, 28240 Fontaine-Simon
              </p>
              <p className="font-inter text-base">
                <span className="font-semibold">SIREN :</span> 831 276 001
              </p>
              <p className="font-inter text-base">
                <span className="font-semibold">SIRET :</span> 831 276 001 00011
              </p>
              <p className="font-inter text-base">
                <span className="font-semibold">N° TVA Intracommunautaire :</span> FR16 831 276 001
              </p>
              <p className="font-inter text-base">
                <span className="font-semibold">Code NAF/APE :</span> 58.14Z - Édition de revues et périodiques
              </p>
            </div>

            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6 mt-12">
              Direction et fondation
            </h2>
            
            <div className="space-y-4 mb-8">
              <p className="font-inter text-base">
                <span className="font-semibold">Fondateur :</span> Jean-Baptiste Giraud
              </p>
              <p className="font-inter text-base">
                <span className="font-semibold">Directeur de la publication :</span> Jean-Baptiste Giraud
              </p>
              <p className="font-inter text-base">
                <span className="font-semibold">Date de création :</span> Février 2007
              </p>
            </div>

            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6 mt-12">
              Organisations affiliées
            </h2>
            
            <div className="space-y-4 mb-8">
              <p className="font-inter text-base">
                • Versailles Press Club
              </p>
              <p className="font-inter text-base">
                • Versailles Club d'Affaires
              </p>
            </div>

            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6 mt-12">
              Hébergement
            </h2>
            
            <p className="font-lora text-base mb-8">
              Le site VersaillesPlus.fr est hébergé par des services cloud sécurisés.
            </p>

            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6 mt-12">
              Propriété intellectuelle
            </h2>
            
            <p className="font-lora text-base leading-relaxed mb-4">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
              et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
              les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
            
            <p className="font-lora text-base leading-relaxed mb-8">
              La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
              formellement interdite sauf autorisation expresse du directeur de la publication.
            </p>

            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6 mt-12">
              Données personnelles
            </h2>
            
            <p className="font-lora text-base leading-relaxed mb-4">
              Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée et au Règlement 
              européen n°2016/679/UE du 27 avril 2016 (RGPD), vous bénéficiez d'un droit d'accès, de 
              rectification, de portabilité et d'effacement de vos données ou encore de limitation du traitement.
            </p>
            
            <p className="font-lora text-base leading-relaxed">
              Pour exercer ces droits ou pour toute question relative au traitement de vos données, 
              vous pouvez contacter la rédaction.
            </p>

            <h2 className="font-playfair text-2xl font-bold text-stone-900 mb-6 mt-12">
              Commission Paritaire des Publications et Agences de Presse
            </h2>
            
            <p className="font-lora text-base leading-relaxed">
              VersaillesPlus.fr est une publication d'actualité locale en ligne, éditée par Le Pool Presse SAS, 
              société spécialisée dans l'édition de revues et périodiques. Publication fondée en février 2007.
            </p>

          </article>
        </div>
      </section>
    </div>
  );
}
